const IframeLoad = () => {
  const scope = { callBack: '&iframeLoad' }

  const link = (scope, element, attrs) => {
    element.on('load', () => {
      return scope.callBack()
    })
  }

  return { scope, link }
}

export default IframeLoad



// WEBPACK FOOTER //
// ./src/app/common/validators/iframe-load.js